<template>
  <div class="flex flex-col">

    <plus-button v-if="!prompting" @click="open()">
      {{addButtonText}}
    </plus-button>
    <template v-else>
      <input type="text" class="inp my-2 p-2" :placeholder="placeholder" v-model="value" ref="inputbox">
      <button class="btn btn-2 uppercase text-sm font-bold" @click="send()">{{saveButtonText}}</button>
    </template>
  </div>
</template>

<script>
import PlusButtonVue from './PlusButton.vue'
export default {
  components: {
    PlusButton: PlusButtonVue
  },
  data() {
    return {
      prompting: false,
      value: ''
    }
  },
  props: {
    addButtonText: String,
    placeholder: String,
    saveButtonText: String,
  },
  methods: {
    open() {
      this.prompting = true
      this.$nextTick(() => {
        this.$refs.inputbox.focus()
      })

    },
    send() {
      this.$emit('input', this.value)
      this.prompting = false
      this.value = ''
    }
  }
}
</script>

<style>

</style>